import { Paragraph, Flex, Text } from 'theme-ui';
import { Svg } from '@snippets';

import { useOkendoStars, useOkendoScrollToReviews } from '@hooks';

import { OkendoStarsIcons } from './OkendoStarsIcons';

// Fetches stars data from yotpo and then renders them
export function OkendoStars({
  legacyResourceId,
  isProductItem = false,
  isPdp = false,
  withCta = true,
  withScroll = true,
  onClickedStar = () => {},
  fullColor = 'black',
  emptyColor = 'black',
  ...props
}) {
  const { stars } = useOkendoStars({
    productId: legacyResourceId,
  });
  const { averageScore, totalReviews, fiveStarTotalReviews } = stars || {};
  const { scrollToReviews } = useOkendoScrollToReviews();

  return (
    <Flex
      variant="flex.row.start.center"
      data-comp={OkendoStars.displayName}
      key={averageScore + totalReviews}
      className={totalReviews > 0 ? '' : 'hidden'}
    >
      <Flex
        variant="flex.row.start.center"
        tabIndex="0"
        onClick={withScroll ? scrollToReviews : null}
        {...props}
        sx={{
          minHeight: '18px',
          my: 3,
          cursor: 'pointer',
          ...props.sx,
        }}
        className={totalReviews > 0 ? `${props?.className}` : `before:hidden`}
      >
        {totalReviews >= 0 && (
          <>
            <OkendoStarsIcons
              totalReviews={totalReviews}
              averageScore={averageScore}
              onClickedStar={onClickedStar}
              fullColor={fullColor}
              emptyColor={emptyColor}
            />

            {withCta ? (
              <Paragraph
                data-comp={`${OkendoStars.displayName}Total`}
                aria-label={`${totalReviews} reviews`}
                variant="link2"
                sx={{
                  pl: 4,
                  textDecoration: withScroll ? 'underline' : 'none',
                  mr: 'auto',
                  span: { variant: 'text.sm' },
                  position: 'relative',
                  top: '-3px',
                }}
              >
                {totalReviews ? (
                  <Text data-comp={`${OkendoStars.displayName}TotalText`}>
                    ({totalReviews})
                  </Text>
                ) : (
                  <Text
                    data-comp={`${OkendoStars.displayName}TotalText`}
                    sx={{ display: ['none', 'inline-block'] }}
                  >
                    (0)
                  </Text>
                )}
              </Paragraph>
            ) : null}
          </>
        )}
      </Flex>
      {isPdp && fiveStarTotalReviews > 0 && (
        <Flex
          variant="flex.row.start.center"
          tabIndex="0"
          {...props}
          sx={{
            background: '#F3F3F3',
            borderRadius: '100px',
            marginLeft: '12px',
            color: '#222222',
            fontSize: ['11px', '14px'],
            padding: ['4px 8px', '6px 12px'],
            gap: ['4px', '8px'],
          }}
          className="okendoFiveStars"
        >
          <Svg
            alt={`${fiveStarTotalReviews} 5-Star Reviews`}
            viewBox="0 0 16 17"
            src="/svgs/okendo/five-stars.svg#five-stars"
            sx={{
              width: '16px',
              height: '17px',
              color: '#222222',
            }}
          />
          <span>
            {fiveStarTotalReviews.toLocaleString('en-US')} 5-Star Reviews
          </span>
        </Flex>
      )}
    </Flex>
  );
}

OkendoStars.displayName = 'OkendoStars';
